import { createSlice, PayloadAction, Reducer } from '@reduxjs/toolkit';

interface PopupState {
  popupName: string | null;
  options: unknown;
}

const initialState: PopupState = {
  popupName: null,
  options: null,
};

const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    popupRequested: (state, action: PayloadAction<PopupState>) => action.payload,
    popupCloseRequested: () => initialState,
  },
});

export function closeCurrentPopup() {
  return popupSlice.actions.popupCloseRequested();
}

interface PopupReducerAndActionCreators<PopupMap> {
  readonly popupReducer: Reducer<
    | {
        [PopupName in Extract<keyof PopupMap, string>]: {
          readonly popupName: PopupName;
          readonly options: PopupMap[PopupName];
        };
      }[Extract<keyof PopupMap, string>]
    | { readonly popupName: null; readonly options: null }
  >;
  readonly showPopup: <PopupName extends Extract<keyof PopupMap, string>>(
    popupName: PopupName,
    ...args: PopupMap[PopupName] extends undefined ? [] : [PopupMap[PopupName]]
  ) => ReturnType<typeof popupSlice.actions.popupRequested>;
}

export function createPopupReducerAndActionCreators<PopupMap>(): PopupReducerAndActionCreators<PopupMap> {
  return {
    popupReducer: popupSlice.reducer,
    showPopup: (popupName, options) =>
      popupSlice.actions.popupRequested({
        popupName,
        options,
      }),
  } as PopupReducerAndActionCreators<PopupMap>;
}
